/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserCoinAccount
 */
export interface UserCoinAccount {
    /**
     * The token account address
     * @type {string}
     * @memberof UserCoinAccount
     */
    account: string;
    /**
     * The owner wallet of the token account
     * @type {string}
     * @memberof UserCoinAccount
     */
    owner: string;
    /**
     * The balance of the coin in the user's account (in wei)
     * @type {number}
     * @memberof UserCoinAccount
     */
    balance: number;
    /**
     * The balance of the coin in the user's account in USD
     * @type {number}
     * @memberof UserCoinAccount
     */
    balanceUsd: number;
    /**
     * Whether the account is in the user's in-app wallet
     * @type {boolean}
     * @memberof UserCoinAccount
     */
    isInAppWallet: boolean;
}

/**
 * Check if a given object implements the UserCoinAccount interface.
 */
export function instanceOfUserCoinAccount(value: object): value is UserCoinAccount {
    let isInstance = true;
    isInstance = isInstance && "account" in value && value["account"] !== undefined;
    isInstance = isInstance && "owner" in value && value["owner"] !== undefined;
    isInstance = isInstance && "balance" in value && value["balance"] !== undefined;
    isInstance = isInstance && "balanceUsd" in value && value["balanceUsd"] !== undefined;
    isInstance = isInstance && "isInAppWallet" in value && value["isInAppWallet"] !== undefined;

    return isInstance;
}

export function UserCoinAccountFromJSON(json: any): UserCoinAccount {
    return UserCoinAccountFromJSONTyped(json, false);
}

export function UserCoinAccountFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserCoinAccount {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'account': json['account'],
        'owner': json['owner'],
        'balance': json['balance'],
        'balanceUsd': json['balance_usd'],
        'isInAppWallet': json['is_in_app_wallet'],
    };
}

export function UserCoinAccountToJSON(value?: UserCoinAccount | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'account': value.account,
        'owner': value.owner,
        'balance': value.balance,
        'balance_usd': value.balanceUsd,
        'is_in_app_wallet': value.isInAppWallet,
    };
}

